/* eslint-disable no-unused-vars */

import React, { useMemo } from 'react';

import style from './style.module.scss';
import Icon from '@components/icon-component';
import Button from '@components/button';

const Footer = ({
  moveOn,
  showDeleteBtn,
  setResetEquipmentEvent,
  commentForReviewer = '',
  showToasterOfAddingOnlyCommentsCOmments,
  vesselEquipmentId,
  isVesselUpdated
}) => {
  const isSaveBtnDisabled = useMemo(() => {
    const condition =
      vesselEquipmentId &&
      !isVesselUpdated &&
      !localStorage.getItem('equipmentDetailsUpdated') &&
      !moveOn
        ? true
        : localStorage.getItem('equipmentDetailsUpdated') ||
          localStorage.getItem('onlyPSVDataUpdatedForVessel') ||
          moveOn
        ? false
        : true;
    return condition;
  }, [
    localStorage.getItem('equipmentDetailsUpdated'),
    localStorage.getItem('onlyPSVDataUpdatedForVessel'),
    moveOn,
    vesselEquipmentId,
    isVesselUpdated
  ]);

  return (
    <div className={style.footerBtn}>
      {showDeleteBtn && (
        <Icon
          name={'Delete button'}
          alt=""
          onClick={() => {
            setResetEquipmentEvent(true);
          }}
        />
      )}

      <Button
        btnClass={`btn-fill button-large ${
          isSaveBtnDisabled && commentForReviewer && 'btn-fill-disabled'
        } `}
        type={isSaveBtnDisabled && commentForReviewer ? 'button' : 'submit'}
        form={isSaveBtnDisabled && commentForReviewer ? '' : 'addOrEditEquipmentContainer'}
        text="SAVE"
        {...(isSaveBtnDisabled && commentForReviewer ? {} : { disabled: isSaveBtnDisabled })}
        {...(isSaveBtnDisabled && commentForReviewer
          ? {
              onClick: () => {
                showToasterOfAddingOnlyCommentsCOmments();
              }
            }
          : {})}
      />
    </div>
  );
};

export default Footer;
